<template>
    <b-modal size="lg" id="defaultModal" hide-footer no-close-on-esc no-close-on-backdrop hide-header centered>
        <AddDeliveryAddress v-if="action.action === 'addDeliveryAddress'" :action="action"> </AddDeliveryAddress>

        <EditDeliveryAddress v-if="action.action === 'editDeliveryAddress'" :action="action"> </EditDeliveryAddress>
    </b-modal>
</template>

<script>
import AddDeliveryAddress from "../actions/AddDeliveryAddress";
import EditDeliveryAddress from "../actions/EditDeliveryAddress";

export default {
    props: ["action", "actionShipOrder"],
    data() {
        return {};
    },
    components: {
        AddDeliveryAddress,
        EditDeliveryAddress
    }
};
</script>



// WEBPACK FOOTER //
// Modal.vue?3811446c